<template>
  <v-container style="max-width: 100%">
    <v-row class="text-center">
      <v-col class="mb-4" cols="12" sm="12" md="8">
        <div v-if="liveVideoId">
          <iframe width="100%" height="600" :src="embedUrl" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <p class="subheading font-weight-regular">
          To connect with other viewers,
          <br>please join our online
          <a
            href="https://discord.gg/agenda-freetv"
            target="_blank"
          >Discord Community</a>
        </p>
      </v-col>
      <v-col class=".d-none .d-xs-flex mb-4" cols="12" sm="12" md="4">
        <div v-if="liveVideoId">
          <iframe width="100%" height="600" :src="chatUrl" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        </div>
        <p class="subheading font-weight-regular">
          If you'd like to support the channel,
          <a
            href="https://www.paypal.com/donate/?cmd=_s-xclick&hosted_button_id=XXUKLNXKHXAGL"
            target="_blank"
          >please donate via Paypal</a> or check us out <a href="https://patreon.com/agendafreetv" target="_blank">on Patreon</a>.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="mb-4" cols="12" sm="12" md="8">
        <v-row>
          <v-col class="mb-4 text-center" cols="12" sm="12" md="6">
            <h4>Donate with Bitcoin</h4>
            <img src="/bitcoin_updated.png" height="300" width="300"/>
            <p>3PmUHHJ79LiHQEaLsACkA9cjAZZG1M7RYW</p>
          </v-col>
          <v-col class="mb-4 text-center" cols="12" sm="12" md="6">
            <h4>Donate with Ethereum</h4>
            <img src="/ethereum_updated.png" height="300" width="300"/>
            <p>0x9B9a7fcAc59898E7BdCE5Ddd4775dbF7803996bb</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="mb-4 text-center" cols="12" sm="12" md="6">
            <h4>Donate with Dogecoin</h4>
            <img src="/dogecoin_updated.png" height="300" width="300"/>
            <p>DLgzYZsbPpqkWED7jFWsHjmLgBwRAtg76E</p>
          </v-col>
          <v-col class="mb-4 text-center" cols="12" sm="12" md="6">
            <h4>Donate with Litecoin</h4>
            <img src="/litecoin_updated.png" height="300" width="300"/>
            <p>MUQzjU67R2iwHo424ndCZzbbJZa22XR99S</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="mb-4 text-center" cols="12" sm="12" md="6">
            <h4>Donate with Bitcoin Cash</h4>
            <img src="/bitcoincash_updated.png" height="300" width="300"/>
            <p>qr0k8f2dcplsmyvuu2lgdggr2rvu3sqqmscnvcgzrq</p>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="mb-4" cols="12" sm="12" md="4">
        <a class="twitter-timeline" href="https://twitter.com/lookner?ref_src=twsrc%5Etfw">Tweets by lookner</a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

  export default {
    name: 'Agenda Free TV',
    mounted: async function() {
      let twitterScript = document.createElement('script');
      twitterScript.setAttribute('src', 'https://platform.twitter.com/widgets.js');
      document.head.appendChild(twitterScript);
    },
    created: async function() {
      // Grab RSS Feed From Youtube

      // const response = await axios.get("http://localhost:3000/api/is_live");
      // this.isLive = response.data.is_live;
      // if (this.isLive) {
        console.log(process.env);
        let currentVideoResponse = null;
        if (process.env.NODE_ENV === "production") {            
          currentVideoResponse = await axios.get("https://api.agendafreetv.com/api/last_video");
        } else {
          currentVideoResponse = await axios.get("http://localhost:3000/api/last_video");
        }
        
        this.liveVideoId = currentVideoResponse.data.video.yt_id;
        console.log(currentVideoResponse);
        this.embedUrl = `https://www.youtube.com/embed/${this.liveVideoId}?autoplay=1`;
        if (process.env.NODE_ENV === "production") {            
          this.chatUrl = `https://www.youtube.com/live_chat?v=${this.liveVideoId}&embed_domain=agendafreetv.com`;
        } else {
          this.chatUrl = `https://www.youtube.com/live_chat?v=${this.liveVideoId}&embed_domain=localhost`;
        }
        console.log(this.embedUrl);
      // }
    },

    data: () => ({
      isLive: false,
      liveVideo: null,
      liveVideoId: null,
      embedUrl: null,
      chatUrl: null,
      rss: [],
    }),
  }
</script>
<style scoped>
.ui.button {min-width:300px !important; min-height:50px !important;}
</style>
